import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { SessionProvider } from "./shell/session";
import { stopEntryGuard } from "./shell/entryGuard";
import { installStaleBundleReload } from "./shell/staleBundle";
import { UnsavedGuardProvider } from "./unsavedGuard";
import "./theme.css";

// Before the first render, so a tab whose bundle was replaced under it is
// already listening when the person clicks through to a lazily-loaded page
// (#457). Never removed: it lives as long as the document. The entry running
// means every chunk it imports statically loaded, so index.html's guard for
// those stands down here and a failed chunk from now on is this one's (#2138).
stopEntryGuard();
installStaleBundleReload();

// A data router, with one route that is the whole application: `App` keeps
// its own `<Routes>`. The data router is what lets a form with an unsent edit
// ask before a navigation leaves it (`useBlocker`, UX-011); `BrowserRouter`
// offers no blocker.
const router = createBrowserRouter([{
  path: "*",
  element: <UnsavedGuardProvider><SessionProvider><App /></SessionProvider></UnsavedGuardProvider>,
}]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
